import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { iconButtonDriverFactory } from '../IconButton/IconButton.driver';
import { SocialBarIconTestHook } from './consts';

export const socialBarDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
    async childrenCount(hook = SocialBarIconTestHook) {
      const SocialBarIcons = base.$$(`[data-hook="${hook}"]`);

      return SocialBarIcons.count();
    },
    socialBarIconAt: async (index: number, hook = SocialBarIconTestHook) => {
      const socialBarIcons = await base.getAll(`[data-hook="${hook}"]`);
      const socialBarIcon = socialBarIcons.at(index);
      const driver = iconButtonDriverFactory(socialBarIcon);
      return driver;
    },
  };
};

export type SocialBarDriver = ReturnType<typeof socialBarDriverFactory>;
